import React, { useEffect, useState, useCallback } from "react";
import { customerApi } from "../lib/customerApi";

// Keeps track of the signed-in customer across the app.
const CustomerContext = React.createContext({
  customer: null,
  loading: true,
  refresh: async () => {},
});

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip the /me check — the callback
    // will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const r = await customerApi.get("/auth/me");
      setCustomer(r.data);
    } catch {
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <CustomerContext.Provider value={{ customer, loading, refresh, setCustomer }}>
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => React.useContext(CustomerContext);
